import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDetail(detail) {
  if (detail == null) return "Eroare la autentificare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("hm-admin-token", data.token);
      navigate("/admin/lead-uri");
    } catch (err) {
      setError(formatDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-base px-4" data-testid="admin-login-page">
      <SEO title="Autentificare Administrare | HEAVY METAL" description="Autentificare panou de administrare HEAVY METAL." noindex />
      <div className="w-full max-w-sm border border-ink/10 bg-surface p-8">
        <Link to="/" data-testid="admin-login-logo">
          <img src="/logo.png" alt="HEAVY METAL" className="mx-auto h-24 w-auto" />
        </Link>
        <p className="kicker mt-6 text-center">Administrare</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="kicker mb-2 block">Utilizator</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              data-testid="admin-username-input"
              className="w-full border border-ink/15 bg-base px-4 py-3 text-sm text-ink outline-none transition-colors focus:border-gold"
            />
          </div>
          <div>
            <label className="kicker mb-2 block">Parolă</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              data-testid="admin-password-input"
              className="w-full border border-ink/15 bg-base px-4 py-3 text-sm text-ink outline-none transition-colors focus:border-gold"
            />
          </div>
          {error && (
            <p className="border border-red-300 bg-red-50 px-4 py-2.5 text-sm text-red-700" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-sweep w-full bg-ink px-6 py-3.5 text-xs font-semibold uppercase tracking-widest text-base transition-colors disabled:opacity-60"
          >
            {loading ? "Se conectează..." : "Autentificare"}
          </button>
        </form>
      </div>
    </div>
  );
}
